// extracted by mini-css-extract-plugin
export default {"modal__content":"Error_modal__content__+TZcF","modal__actions":"Error_modal__actions__Qp5NC"};